import React, { useState, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { useToast } from "../context/ToastContext";
import AnimatedPage from "./AnimatedPage";

const correctPasscode = "2024";

const LoginForm = ({ setAuthenticated }) => {
    const [passcode, setPasscode] = useState("");
    const { language, setLanguage, t } = useLanguage();
    const { showToast } = useToast();

    const handleLogin = (e) => {
        e.preventDefault();
        if (passcode === correctPasscode) {
            setAuthenticated(true);
            const expirationTime = new Date().getTime() + 600000; // 10 minutes expiry
            localStorage.setItem(
                "authenticated",
                JSON.stringify({ value: true, expires: expirationTime })
            );
        } else {
            showToast(t("incorrectPasscode"), "danger");
        }
    };

    useEffect(() => {
        const authenticatedData = localStorage.getItem("authenticated");
        if (authenticatedData) {
            const { value, expires } = JSON.parse(authenticatedData);
            if (new Date().getTime() < expires) {
                setAuthenticated(value);
            } else {
                localStorage.removeItem("authenticated"); // Clear expired authentication data
            }
        }
    }, [setAuthenticated]);

    return (
        <AnimatedPage>
            <div className="min-h-screen flex items-center justify-center relative px-4">
                {/* Language Switcher in top right */}
                <div className="absolute top-4 right-4 z-50 flex items-center gap-1 bg-white/80 backdrop-blur-md px-1.5 py-1.5 rounded-2xl border border-blue-100 shadow-sm">
                    <button
                        type="button"
                        onClick={() => setLanguage("en")}
                        className={`px-3 py-1 text-xs font-bold rounded-xl transition-all ${
                            language === "en"
                                ? "bg-[#4580d6] text-white shadow-sm"
                                : "text-slate-500 hover:text-[#4580d6]"
                        }`}
                    >
                        English
                    </button>
                    <button
                        type="button"
                        onClick={() => setLanguage("hi")}
                        className={`px-3 py-1 text-xs font-bold rounded-xl transition-all ${
                            language === "hi"
                                ? "bg-[#4580d6] text-white shadow-sm"
                                : "text-slate-500 hover:text-[#4580d6]"
                        }`}
                    >
                        हिन्दी
                    </button>
                </div>

                {/* Square Grid Background Layer */}
                <div className="fixed inset-0 h-full w-full -z-10 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] [background-size:24px_24px] pointer-events-none"></div>

                <div className="glass-card w-full max-w-sm p-8 rounded-3xl shadow-2xl border border-white/60">
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-[#4580d6] shadow-md border border-blue-100 mb-4">
                            <i className="fa-solid fa-lock text-3xl"></i>
                        </div>
                        <h2 className="text-2xl font-bold text-slate-800 tracking-tight">{t("appName")}</h2>
                        <p className="text-slate-500 text-sm font-medium">{t("loginPrompt")}</p>
                    </div>

                    <form onSubmit={handleLogin} className="space-y-6">
                        <div className="space-y-1.5">
                            <label className="text-[10px] font-bold uppercase tracking-wider text-slate-500 ml-1">{t("passcode")}</label>
                            <input
                                type="password"
                                value={passcode}
                                onChange={(e) => setPasscode(e.target.value)}
                                placeholder={t("passcodePlaceholder")}
                                className="flex h-12 w-full rounded-xl border border-blue-50 bg-white/60 px-4 py-2 text-center text-lg tracking-widest form-input-focus shadow-sm placeholder:tracking-normal"
                                autoFocus
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full btn-soft-blue h-12 rounded-xl text-white font-bold text-sm shadow-lg shadow-blue-200 hover:shadow-blue-300 transition-all active:scale-95 flex items-center justify-center gap-2"
                        >
                            <span>{t("loginSecurely")}</span>
                            <i className="fa-solid fa-arrow-right"></i>
                        </button>
                    </form>
                </div>
            </div>
        </AnimatedPage>
    );
};

export default LoginForm;
